import { useState } from 'react';
import { Copy, Check, Download, KeyRound } from 'lucide-react';
import { downloadBlob } from '../../utils/download';

/**
 * The one moment recovery codes are readable. They are shown after enrolment and after a
 * deliberate regeneration; the server keeps only bcrypt hashes, so they cannot be shown
 * again — which is exactly why this screen insists on an acknowledgement.
 */
export default function RecoveryCodes({ codes, onDone, doneLabel = 'I have saved these codes' }) {
  const [copied, setCopied] = useState(false);
  const [acknowledged, setAcknowledged] = useState(false);
  const text = codes.join('\n');

  return (
    <div className="stack" style={{ gap: 14 }}>
      <div className="row" style={{ gap: 8 }}>
        <KeyRound size={16} />
        <strong>Recovery codes</strong>
      </div>
      <div className="muted" style={{ fontSize: 13 }}>
        Each code signs you in once if you lose your authenticator. Keep them somewhere safe and private — they are not
        shown again.
      </div>

      <div
        className="panel"
        style={{
          padding: 14,
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
          gap: 8,
          fontFamily: 'var(--mono, ui-monospace, monospace)',
          fontSize: 13.5,
          letterSpacing: '.04em',
        }}
      >
        {codes.map((code) => (
          <span key={code}>{code}</span>
        ))}
      </div>

      <div className="row" style={{ gap: 8 }}>
        <button
          type="button"
          className="btn btn-s"
          onClick={async () => {
            try {
              await navigator.clipboard.writeText(text);
              setCopied(true);
              setTimeout(() => setCopied(false), 2000);
            } catch {
              /* clipboard blocked — the codes are on screen and downloadable */
            }
          }}
        >
          {copied ? <Check size={14} /> : <Copy size={14} />}
          {copied ? 'Copied' : 'Copy'}
        </button>
        <button
          type="button"
          className="btn btn-s"
          onClick={() => downloadBlob(new Blob([`Inditech Document Hub recovery codes\n\n${text}\n`], { type: 'text/plain' }), 'inditech-recovery-codes.txt')}
        >
          <Download size={14} />
          Download
        </button>
      </div>

      <label className="checkbox" style={{ fontSize: 13 }}>
        <input type="checkbox" checked={acknowledged} onChange={(e) => setAcknowledged(e.target.checked)} />
        I have saved these codes somewhere safe
      </label>

      <button type="button" className="btn btn-p btn-lg" disabled={!acknowledged} onClick={onDone}>
        {doneLabel}
      </button>
    </div>
  );
}
